import { apiSlice } from '../app/api/apiSlice';

export const blackListApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    blackList: builder.query({
      query: (params) => 'blacklist' + params,
      keepUnusedDataFor: 3,
      providesTags: (result, error, arg)=>[
        {type:'BlackList', id: 'LIST'},
      ]
    }),
    addBlackList: builder.mutation({
      query: (newBlackList)=>({
        url: 'blacklist',
        method: 'post',
        body: newBlackList
      }),
      invalidatesTags: ["BlackList"]
    }),
  })
})

export const { useBlackListQuery, useAddBlackListMutation } = blackListApi;
